import React from 'react';
import {
    Box,
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Menu,
    MenuItem,
    Avatar,
    Chip,
} from '@mui/material';
import { AccountCircle } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Breadcrumb from '../Breadcrumb';
import authService from '../../services/authService';

const drawerWidth = 240;
const collapsedDrawerWidth = 64;

const DashboardLayout = ({ children, title, userType }) => {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [sidebarCollapsed, setSidebarCollapsed] = React.useState(() => {
        const saved = localStorage.getItem('sidebarCollapsed');
        return saved ? JSON.parse(saved) : false;
    });
    const currentUser = authService.getCurrentUser();
    
    // Auto-detect userType if not provided
    const detectedUserType = userType || currentUser?.type;

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        authService.logout();
        handleClose();
        navigate('/login');
    };

    const currentDrawerWidth = sidebarCollapsed ? collapsedDrawerWidth : drawerWidth;

    return (
        <Box sx={{ position: 'relative', minHeight: '100vh' }}>
            <Sidebar 
                userType={detectedUserType} 
                onCollapseChange={setSidebarCollapsed}
            />

            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: `${currentDrawerWidth}px`,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    transition: 'left 0.3s ease',
                }}
            >
                <AppBar
                    position="sticky"
                    sx={{
                    backgroundColor: 'white',
                    color: 'text.primary',
                    boxShadow: 1,
                        zIndex: (theme) => theme.zIndex.drawer - 1,
                }}
            >
                <Toolbar>
                    <Box sx={{ flexGrow: 1 }}>
                        <Typography variant="h6" component="div">
                            {title}
                        </Typography>
                        {currentUser?.role && (
                            <Chip
                                label={currentUser.role.name}
                                size="small"
                                color="primary"
                                variant="outlined"
                                sx={{ mt: 0.5 }}
                            />
                        )}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body2" sx={{ mr: 1 }}>
                            {currentUser?.name}
                        </Typography>
                        <IconButton
                            size="large"
                            onClick={handleMenu}
                            color="inherit"
                        >
                            <Avatar sx={{ width: 32, height: 32 }}>
                                <AccountCircle />
                            </Avatar>
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={handleLogout}>Logout</MenuItem>
                        </Menu>
                    </Box>
                </Toolbar>
            </AppBar>

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 3,
                    backgroundColor: '#f5f5f5',
                        overflow: 'auto',
                }}
            >
                <Breadcrumb />
                {children}
                </Box>
            </Box>
        </Box>
    );
};

export default DashboardLayout; 